import { useSelector } from 'react-redux';
import { selectAllEstimation } from '../../../selectors/estimation';

import { selectIsMyHome, selectIsReportReadyPage, selectValuationType } from '../../../selectors/page';
import { EDealType } from '../../../types/dealType';

const DEAL_TYPE_TEXT_MAPPER = {
  [EDealType.Sale]: 'продажи',
  [EDealType.Rent]: 'аренды',
};

export function useDealTypeText(): string | null {
  const valuationType = useSelector(selectValuationType);
  const estimations = useSelector(selectAllEstimation);
  const isReportReady = useSelector(selectIsReportReadyPage);
  const isMyHome = useSelector(selectIsMyHome);

  /**
   * Для сервиса Мой дом - ничего не возвращаем
   * Если открыли страницу готового отчета - ничего не возвращаем
   * Если есть данные по запрошенному типу сделки - ничего не возвращаем
   */
  if (isMyHome || isReportReady || estimations[valuationType].data) {
    return null;
  }

  return DEAL_TYPE_TEXT_MAPPER[valuationType];
}
